import { render, staticRenderFns } from "./ProfileTalentProfileImage.vue?vue&type=template&id=646bca66"
import script from "./ProfileTalentProfileImage.vue?vue&type=script&lang=js"
export * from "./ProfileTalentProfileImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports